enum errorMessages {
  "customerError" = "Customers could not be retrieved",
  "serviceFailureError" = "There was an error while fetching the report. Please try again later.",
  "unauthorizedAccessError" = "You are not authorized to view this page. Please contact your administrator for more information."
}
export default errorMessages;
